import classes from './style.module.scss';

const getOpenedSuggestionsClassNames = (isMobile) => {
    const {
        suggestionsContainerOpen,
        suggestionsContainerOpenMobile,
        suggestionsContainerOpenDesktop,
    } = classes;
    const common = suggestionsContainerOpen;
    const specific = isMobile
        ? suggestionsContainerOpenMobile
        : suggestionsContainerOpenDesktop;
    return `${common} ${specific}`;
};

export const getTheme = (isMobile) => ({
    suggestionsContainer: classes.suggestionsContainer,
    suggestionsContainerOpen: getOpenedSuggestionsClassNames(isMobile),
    suggestionsList: classes.suggestionsList,
    suggestion: isMobile ? classes.suggestionMobile : classes.suggestion,
    suggestionFirst: classes.suggestionFirst,
    suggestionHighlighted: classes.suggestionHighlighted,
});

export const INPUT_CHANGE_HANDLES = {
    type: (e, props) => props.onChange(e),
    enter: (e) => e.preventDefault(),
};
